export default "__VITE_ASSET__B$RV$6EF__"